<template>
  <div v-if="product && product.spec && product.spec.length" class="specs">
    <h2 class="light">Construction</h2>
    <Divider />
    <div class="specs-values">
      <div v-for="spec in product.spec" :key="spec.id" class="flex-grid specs-row">
        <div class="flex-col-4-sm specs-title">
          <span>{{ spec.key }}</span>
        </div>
        <div class="flex-col-8-sm specs-value">
          <span>{{ spec.value }}</span>
        </div>
      </div>
      <div class="flex-grid specs-row">
        <div class="flex-col-4-sm specs-title">
          <span>Box Dimensions</span>
        </div>
        <div class="flex-col-8-sm specs-value">
          <template v-for="(boxDimension, index) in boxDimensions">
            <div :key="index">{{ boxDimension.height }}" x {{ boxDimension.width }}" x {{ boxDimension.depth }}"</div>
          </template>
        </div>
      </div>
      <div class="flex-grid specs-row">
        <div class="flex-col-4-sm specs-title">
          <span>SKU No.</span>
        </div>
        <div class="flex-col-8-sm specs-value">
          <span>{{ product.skuNo }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Divider from './Divider.vue';

export default {
  name: 'Specs',
  components: {
    Divider,
  },
  computed: {
    ...mapState('product', ['product']),

    boxDimensions() {
      if (this.product && this.product.box && this.product.box.length) {
        return this.product.box
          .filter((box) => box.height && box.width && box.depth)
          .map((box) => ({
            height: Math.ceil(box.height),
            width: Math.ceil(box.width),
            depth: Math.ceil(box.depth),
          }));
      }
      return [];
    },
  },
};
</script>

<style lang="scss">
@import '~@article/pixel/dist/style/variables';

.specs {
  .divider {
    display: none;
  }

  .specs-values {
    padding: var(--space-3) 0px;

    .specs-row {
      &:not(:first-child) {
        padding-top: var(--space-3);
      }

      &:not(:last-child) {
        padding-bottom: var(--space-3);
        border-bottom: 1px solid var(--grey-light);
      }

      .specs-title {
        text-transform: uppercase;
        font-family: var(--font-bold);
        font-size: var(--font-size-14);
        padding-right: var(--space-2);
        line-height: 1.25rem;
      }

      .specs-value {
        font-size: var(--font-size-14);
      }
    }
  }

  @media (max-width: $tablet-breakpoint - 1) {
    .divider {
      display: block;
      margin-top: 10px;
      margin-bottom: 24px;
    }
  }
}
</style>
